export const defaultTransition = {
	duration: 0.5,
	sease: [ 0.6, 0.01, -0.05, 0.9 ]
};
